import React from 'react';
import AddSupportingDetailsStep from 'pages/components/AddSupportingDetailsStep';

const ReferralsAddSupportingDetails = (props) => (
  <AddSupportingDetailsStep {...props} />
);

export default ReferralsAddSupportingDetails;
